export const ERROR_MSG = {
  INVALID_IMAGE:
    "Image should be less than 2MB. Only  png, jpeg, jpg, webp is supported.",
  INVALID_ABN: "ABN should be 11 digits.",
  INVALID_EMAIL: "Please Provide Valid email address.",
  INVALID_PHONE: "Please Provide Valid phone number.",
  INVALID_PASSWORD: "Password should be at least 8 characters long.",
  INVALID_NAME: "Name should be at least 2 characters long.",
  REQUIRED_ADDRESS: "Address is required.",
  REQUIRED_IMAGE: "Image is required.",
  REQUIRED_SKILLS: "Skills are required.",
  INVALID_FILE: "File should be less than 2MB.",
  SELECT_CUSTOMER: "Select Customer",
  SELECT_PROSPECT: "Select Prospect",
  SELECT_CUSTOMER_USER: "Select Customer User",
  SELECT_PROSPECT_USER: "Select Prospect User",
  SELECT_CONSTRUCTION_TYPE: "Select Construction Type",
  SELECT_ESTIMATION_TYPE: "Select Estimation Type",
  SELECT_SOURCE: "Select Source",
  SELECT_FILE_TYPE: "Please Select File Type",
  SELECT_INSPECTORS: "Select Inspectors",
  SELECT_SITE_INSPECTION: "Select Site Inspection",
  SELECT_STATUS: "Select Status",
  SELECT_TEAM: "Select Team",
  SELECT_CLIENT_TYPE: "Please Select Client type",
  DUE_DATE_REQ: "Due Date is required",
  INVALID_DATE: "Invalid Date",
  INVALID_TIME: "Invalid Time",
  DATE_REQ: "Date is required",
  INVALID_BUILDER_NO: "Builders No. should be a number",
  ITEM_NAME_REQ: "Item Name is Required",
  DESCRIPTION_REQ: "Description is Required",
  DESCRIPTION_MIN: "Description should be at least 1 characters",
  UNIT_REQ: "Unit is Required",
  QUANTITY_REQ: "Quantity is Required",
  PRICE_REQ: "Price is Required",
  MARGIN_REQ: "Margin is Required",
  TOTAL_REQ: "Total is Required",
  PROJECT_ID_MISSING: "Project ID is missing. Please try again",
  LEADS_ID_MISSING: "Leads ID is missing. Please try again",
  REQUIRED: "Required",
};
